/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PractitionerStrictHttpResponse } from '../../practitioner-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganizationLocationModel } from '../../models/organization-location-model';

export interface AdminOrganizationLocationsOrganizationFhirIdGet$Params {
  organizationFhirId: string;
}

export function adminOrganizationLocationsOrganizationFhirIdGet(http: HttpClient, rootUrl: string, params: AdminOrganizationLocationsOrganizationFhirIdGet$Params, context?: HttpContext): Observable<PractitionerStrictHttpResponse<Array<OrganizationLocationModel>>> {
  const rb = new RequestBuilder(rootUrl, adminOrganizationLocationsOrganizationFhirIdGet.PATH, 'get');
  if (params) {
    rb.path('organizationFhirId', params.organizationFhirId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PractitionerStrictHttpResponse<Array<OrganizationLocationModel>>;
    })
  );
}

adminOrganizationLocationsOrganizationFhirIdGet.PATH = '/Admin/OrganizationLocations/{organizationFhirId}';
